module.exports = __webpack_public_path__ + "static/media/campaigns.ed76eace.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/campaigns.svg
// module id = 85
// module chunks = 1